import React, { useEffect } from 'react'
import { useNavigate } from 'react-router'

import { Spinner } from 'portal/lib/primitives'
import { redirectPromise } from 'portal/store/auth/msal'

export const SignInOidc = () => {
  const navigate = useNavigate()

  useEffect(() => {
    let mounted = true

    async function checkSignin() {
      await redirectPromise

      setTimeout(() => {
        if (mounted) {
          navigate('/')
        }
      }, 1000)
    }

    checkSignin()

    return () => {
      mounted = false
    }
  }, [navigate])

  return <Spinner />
}
